export default __webpack_public_path__ + "static/media/JessicaHruska.93af7e3f.jpg";